import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "revico-api-loading--container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "revico-api-loading--contents" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "revico-api-loading--ball-pulse" }, [
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}